import OverviewContent from './ui/content';

const OverviewHome = () => {

    return (
        <div className="flex flex-col flex-1 leading-7 h-screen relative z-50 bg-white w-screen">
            <div className="overflow-auto px-6 py-10 flex-1">
                <div className="xl:w-[1500px] max-w-full mx-auto">

                    <h1 className="text-xl xl:text-3xl border-b border-teal-400 pb-2 flex items-center mb-4">
                        Overview
                    </h1>

                    <OverviewContent/>

                </div>
            </div>
        </div>
    )
};

export default OverviewHome;